// @flow
import { FaFacebook, FaInstagram, FaYoutube } from 'react-icons/fa';
import React from 'react';

type Props = {
  name: string,
  size: string,
  style: string,
  title: string,
  color: string,
};

const SocialIcon = ({
  name = 'facebook',
  size = '1rem',
  style,
  title,
  color = 'black',
}: Props) => {
  switch (name) {
    case 'facebook':
      return (
        <FaFacebook size={size} style={style} title={title} color={color} />
      );

    case 'instagram':
      return (
        <FaInstagram size={size} style={style} title={title} color={color} />
      );

    case 'youtube':
      return (
        <FaYoutube size={size} style={style} title={title} color={color} />
      );
    default:
      return (
        <FaFacebook size={size} style={style} title={title} color={color} />
      );
  }
};

export default SocialIcon;
